// @ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, message } from "antd";
import {
    AudioOutlined,
    CloseOutlined,
    StopOutlined,
    PlayCircleOutlined,
    UserOutlined,
    LinkOutlined
} from "@ant-design/icons";
import EvLogo from "assets/images/chat/evLogo.png";
import Bot from "assets/images/chat/chat_bot.gif";
import Loader from "assets/images/chat/loader.gif";
// import Excerpt from "components/modals/Excerpt";
import { useNavigate } from "react-router-dom";
import { CommonContainer } from "./styles";
import Excerpt from "modals/Excerpt";
import { synthesizeSpeech } from "utils/helpers";
import { arabicRegex } from "utils/constants";
import MicrophoneComponent from "components/MicrophoneComponent";

interface Message {
    type: "user" | "response";
    text: string;
    question?: string;
    context?: any;
    id?: string;
    isHTML?: boolean;
}

interface SimulateTypingCallback {
    (): void;
}


const AskModal = (props: any) => {
    const { onClose, open } = props;
    const containerBody = useRef<HTMLDivElement>(null);
    const [isInitial, setIsInitial] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [text, setText] = useState<string>("");
    const [messageList, setMessageList] = useState<any>([]);
    const [isPlaying, setIsPlaying] = useState<boolean|string>(false);
    const [isContextOpen, setIsContextOpen] = useState<boolean>(false);
    const [context, setContext] = useState<any>();
    const audioRef = useRef<HTMLAudioElement | null>(null);
    const typingIntervalRef = useRef<NodeJS.Timeout | null>(null);
    const controllerRef = useRef(null);
    const microphoneRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        scrollToBottom();
    }, [messageList, isLoading]);

    const scrollToBottom = () => {
        if (containerBody.current) {
            containerBody.current.scrollTop = containerBody.current.scrollHeight;
        }
    };

    const submitText = async (finalTranscript?: any) => {
        const tempText= finalTranscript?? text;
        if(isLoading) return;
        if (!tempText.trim()) return;
        microphoneRef.current?.stopListening();
        controllerRef.current?.abort();
        const controller = new AbortController();
        controllerRef.current = controller;
        stopTyping();
        handleCancel();
        setIsInitial(true);
        setIsLoading(true);
        const userMessage: any = { type: "user", text:tempText };
        setMessageList((prev: any) => [...prev, userMessage]);
        const temp = tempText;
        setText("");
        try {
            const response = await fetch(
                `https://evai.in/awards/answer?question=${encodeURIComponent(
                    temp
                )}`,{
                    signal: controller.signal 
                }
            );
            const res = await response.json();
            const aiMessage = {
                type: "response",
                text: "", // Start with empty text for animation
                question: temp,
                context: res.context,
                id: Date.now().toString(),
            };
            setIsLoading(false);
            setMessageList((prev:any) => [...prev, aiMessage]);
            simulateTyping(res.answer, () => {
                setIsLoading(false);
            });
            handleSpeak(res.answer??'Something went wrong. Please try after some time', aiMessage.id)
        } catch (error) {
            console.error("Error fetching response:", error);
            setIsLoading(false);
        }
    };

    const simulateTyping = (fullText: string, callback: SimulateTypingCallback) => {
        let currentText = "";
        
        typingIntervalRef.current = setInterval(() => {
            if (currentText.length < fullText.length) {
                currentText = fullText.slice(0, currentText.length + 1);
                setMessageList((prev: Message[]) =>
                    prev.map((msg: Message, i: number) =>
                        i === prev.length - 1 ? { ...msg, text: currentText } : msg
                    )
                );
            } else {
                if (typingIntervalRef.current) {
                    clearInterval(typingIntervalRef.current);
                }
                callback?.();
            }
        }, 30);
    };

    
    const handleShareAnswer = (answer:any) => {
        if (navigator.share) {
            navigator
                .share({ title: "IB.Ai Answer", text: answer })
                .catch((error) => console.error("Error sharing:", error));
        } else {
            alert("Sharing is not supported in your browser.");
        }
    };

    const handleClose = () => {
        controllerRef.current?.abort();
        microphoneRef.current?.stopListening();
        stopTyping();
        handleCancel();
        setIsInitial(false);
        setIsLoading(false);
        setText("");
        setMessageList([]);
        handleCancel();
        onClose();
    };

    const handleSpeak = async (text:string, id:string) => {
        handleCancel();
        setIsPlaying(id);
        const isArabic = arabicRegex.test(text)
        try {
            const res = await synthesizeSpeech(text, isArabic ? 'ar-XA-Standard-C' : 'en-GB-Standard-O');
            const audio = new Audio(`data:audio/mp3;base64,${res.audioContent}`);
            audioRef.current = audio;
            audio.onended = () => setIsPlaying(false);
            audio.play();
        } catch (error) {
            console.error('Speech synthesis failed:', error);
        }
    };

    const handleCancel = () => {
        if (audioRef.current) {
            audioRef.current.pause();
            setIsPlaying(false);
        }
    };

    const handleExcerpt = (context: any) => {
        setContext(context);
        setIsContextOpen(true);
    };

    const stopTyping = () => {
        if (typingIntervalRef.current) {
            clearInterval(typingIntervalRef.current);
        }
    };

    const handleTranscriptChange = (transcript: string) => {
        setText(transcript);
    };

    return (
        <>
            <Modal open={open} onCancel={handleClose} footer={null} width={800} centered
             keyboard={false}
             closable={true}
             maskClosable={false}
            >
                <CommonContainer>
                    <div className="___chat_container_wrapper">
                        <div className="__chat_display" ref={containerBody}>
                            {isInitial ? (

                                messageList.map((item: any, index: any) => (
                                    <div
                                        key={index}
                                        className={item.type === "user" ? "___use_resp_set user" : "___use_resp_set"}
                                        style={
                                            item.type === "user"
                                                ? { justifyContent: "end", flexDirection: "row-reverse", textAlign: "right" }
                                                : {}
                                        }
                                    >
                                        <div className="___user">
                                            {item.type === "user" ? (
                                                <UserOutlined style={{ fontSize: "22px" }} />
                                            ) : (
                                                <img src={EvLogo} alt="EV Logo" />
                                            )}
                                        </div>
                                        <div className="___response">
                                            <h2>{item.type === "user" ? "You" : "IB.Ai"}</h2>

                                            {item.isHTML ? (
                                                <div dangerouslySetInnerHTML={{ __html: item.text }} />
                                            ) : (
                                                <p>{item.text}</p>
                                            )}

                                            {item.type === "response" && (
                                                <>
                                                    <div
                                                    className="button_container"
                                                        style={{
                                                            display: "flex",
                                                            gap: "20px",
                                                            alignItems: "center",
                                                            marginTop: "20px",
                                                        }}
                                                    >
                                                        
                                                        {
                                                            <button className="__share" onClick={() => handleShareAnswer(item.text)}>
                                                                🔗 Share
                                                            </button>
                                                        }
                                                        {isPlaying===item.id ? (
                                                            <button className="__share" onClick={handleCancel}>
                                                                <StopOutlined />
                                                            </button>
                                                        ) : (
                                                            <button className="__share" onClick={() => handleSpeak(item.text,item.id)}>
                                                                <PlayCircleOutlined />
                                                            </button>
                                                        )}
                                                        <button className="__share" onClick={() => handleExcerpt(item.context)}>
                                                            Knowledge Excerpt
                                                        </button>

                                                        <button
                                                            className="__share"
                                                            onClick={() => {
                                                                navigator.clipboard.writeText(item.text || item.text);
                                                                message.success("Copied to clipboard!");
                                                            }}
                                                        >
                                                            📋 Copy
                                                        </button>

                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="__initial_loader">
                                    <img src={Bot} alt="Bot" />
                                    <span>
                                        Ask anything from <b>{'Awards'}</b>
                                    </span>
                                </div>
                            )}
                            {isLoading && (
                                <div className="__loading">
                                    <img src={Loader} alt="Loading" />
                                    Generating Answer...
                                </div>
                            )}
                        </div>
                        <div className="___send_form">
                            <textarea
                                className="___text_area"
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                                placeholder="Ask me anything!"
                                onKeyDown={(e) => e.key === "Enter" && submitText(null)}
                            />
                            <div className="__right_btn_actions">
                                
                            <MicrophoneComponent 
                                onTranscriptChange={handleTranscriptChange}
                                disabled={isLoading}
                                ref={microphoneRef}
                                onAutoSubmit={submitText}
                            />
                                <Button className="___ask_btn" onClick={()=>submitText(null)} disabled={!text.trim()||isLoading}><svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" fill="#fff"><path d="M0 0h24v24H0z" fill="none" /><path d="M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z" /></svg>Ask</Button>
                            </div>
                        </div>
                    </div>
                </CommonContainer>
            </Modal>
            <Excerpt open={isContextOpen} onClose={() => setIsContextOpen(false)} context={context} />
        </>
    );
};

export default AskModal;
